import React from 'react';
import styled from 'styled-components';

import LoadingIndicator from 'components/LoadingIndicator';
import { RenderWithDelay } from 'containers/RenderWithDelay';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const LoadingSection = ({ delay }: { delay?: number }) => (
  <RenderWithDelay delay={delay}>
    <Container>
      <LoadingIndicator />
    </Container>
  </RenderWithDelay>
);

// eslint-disable-next-line import/no-default-export
export default LoadingSection;
